import React, { useEffect, useState } from 'react';
import Big9Card from './Big9Card';
import {
    WrapperResults,
    HR,
    WrapperResultsCards,
    WrapperResultsTopBar,
    Divider,
    ResultsCont,
    WrapperResultsContent,
    ResultsTopBar,
    ControlsWrapper,
    BackArrow,
    ResultsTopBarCont,
} from './styled';
import Big9Service from '../../utils/Big9Service';
import Big9ServiceTerminal from '../../utils/Big9ServiceTerminal';
import Button from '../../ui/Button';
import {
    formatDate,
    getBig9ResultPercents,
    isTerminal,
} from '../../utils/UiHelper';
import Big9Turnover from './Big9Turnover';
import SportRadarWidget from '../SportRadarWidget';
import { detectMobile } from '../../utils/UiHelper';
import backImage from '../../images/icons/arrowLeft.svg';
import darkArrow from './../../images/arrowRight.svg';
import styled from 'styled-components';
import Big9PotentialEarnings from './Big9PotentialEarnings';
import { getOngoingEvent } from '../../features/SpilKlub/state/helpers';

const requestByPlatform = isTerminal() ? Big9ServiceTerminal : Big9Service;

const payoutDefault = {
    payouts: {},
    numberOfSystems: 0,
    turnover: 0,
};

const BackButtonWrapper = styled.div`
    display: ${({ display }) => display || 'none'};
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    button {
        width: auto;
    }
`;

const Big9Results = () => {
    const [activeId, setActiveId] = useState(null);
    const [events, setEvents] = useState([]);
    const [eventsResults, setEventsResults] = useState([]);
    const [earnings, setEarnings] = useState(null);
    const [externalId, setExternalId] = useState('');
    const [payoutsData, setPayoutsData] = useState(payoutDefault);
    const [isVisibleMobRadar, setIsVisibleMobRadar] = useState(false);
    const [sportRadarType, setSportRadarType] = useState('topdown');
    const [disabledLeftButton, setDisabledLeftButton] = useState(true);

    useEffect(() => {
        requestByPlatform
            .getResults()
            .then((res) => {
                if (res.data) {
                    setEvents([...res.data]);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    useEffect(
        () => {
            if (events.length > 0) {
                setEventsResults(events[0]?.items);
                setExternalId(events[0].items[0].externalId);
                setEarnings(events[0]?.projections);
                setPayoutsData({
                    ...payoutsData,
                    payouts: {
                        ...events[0].payouts,
                    },
                    numberOfSystems: events[0].numberOfSystems,
                    turnover: events[0].turnover,
                });
            }
        },
        [events]
    );

    const getTabsButtons = (events) => {
        return Object.keys(events).map((key, index) => {
            return (
                <li key={index}>
                    <Button
                        width={detectMobile() ? '114px' : '100px'}
                        lightBlue
                        className="resultButton"
                        onClick={() => {
                            tabClickHandler(key);
                        }}
                        active={
                            activeId === null ? index === 0 : key === activeId
                        }
                    >
                        {formatDate(events[key].startTime, 'DD. MMM')}
                    </Button>
                </li>
            );
        });
    };

    const tabClickHandler = (eventId) => {
        setActiveId(eventId);
        setEventsResults(events[eventId].items);

        setPayoutsData({
            ...payoutsData,
            payouts: {
                ...events[eventId].payouts,
            },
            numberOfSystems: events[eventId].numberOfSystems,
            turnover: events[eventId].turnover,
        });
        setEarnings(events[eventId]?.projections);
        setExternalId(events[eventId].items[0].externalId);
    };

    const getEventsResults = (resultItems) => {
        return resultItems.map((item, index) => {
            let oddsPercents = getBig9ResultPercents(item);

            return (
                <Big9Card
                    key={index}
                    competition={item.competition}
                    startTime={item.kickoff}
                    eventName={item.name}
                    number={item.nr}
                    country={item.country}
                    matchResult={item.score}
                    results={item.result}
                    oddsPercents={oddsPercents}
                    isVisiblePercents
                    externalId={item.externalId}
                    chooseExternalId={(externalId) => {
                        setExternalId(externalId);
                        showMatchPlugin();
                    }}
                    status={item.status}
                    isResults
                />
            );
        });
    };

    const showMatchPlugin = () => {
        if (window.innerWidth < 1366) {
            setSportRadarType('single');
            setIsVisibleMobRadar(true);
            document.getElementsByClassName('desktop')[0].style =
                'overflow: hidden';
        }
    };

    const hideMatchPlugin = () => {
        setIsVisibleMobRadar(false);
        document.getElementsByClassName('desktop')[0].style = 'overflow: auto';
    };

    const scrollToRight = () => {
        let el = document.getElementById('resultsTopBarCont');
        el.scroll({
            left: +300,
            behavior: 'smooth',
        });
        if (el.offsetLeft > 0) {
            setDisabledLeftButton(!disabledLeftButton);
        }
    };
    const scrollToLeft = () => {
        let el = document.getElementById('resultsTopBarCont');
        el.scroll({
            left: 0,
            behavior: 'smooth',
        });
        if (el.offsetLeft > 0) {
            setDisabledLeftButton(!disabledLeftButton);
        }
    };

    return (
        <WrapperResults>
            <Divider
                padding="0 39px 0 0 "
                className={isTerminal() ? 'terminal results' : null}
            >
                <ResultsCont className={isTerminal() ? 'terminal' : null}>
                    <WrapperResultsTopBar>
                        {!isTerminal() ? (
                            <ControlsWrapper className={'left'}>
                                <Button
                                    display={'block'}
                                    margin={'0 8px 0 0'}
                                    padding={'0'}
                                    width={'44px'}
                                    height={'44px'}
                                    lightBlue
                                    onClick={scrollToLeft}
                                    disabled={disabledLeftButton}
                                >
                                    <img src={darkArrow} alt="" />
                                </Button>
                            </ControlsWrapper>
                        ) : null}
                        <ResultsTopBar
                            className={isTerminal() ? 'terminal' : null}
                        >
                            <ResultsTopBarCont id={'resultsTopBarCont'}>
                                {events.length > 0
                                    ? getTabsButtons(events)
                                    : null}
                            </ResultsTopBarCont>
                        </ResultsTopBar>
                        {!isTerminal() ? (
                            <ControlsWrapper>
                                <Button
                                    display={'block'}
                                    margin={'0 8px 0 0'}
                                    padding={'0'}
                                    width={'44px'}
                                    height={'44px'}
                                    lightBlue
                                    onClick={scrollToRight}
                                    disabled={!disabledLeftButton}
                                >
                                    <img src={darkArrow} alt="" />
                                </Button>
                            </ControlsWrapper>
                        ) : null}
                    </WrapperResultsTopBar>

                    <WrapperResultsContent>
                        <Big9Turnover
                            payoutsData={payoutsData}
                            isResultPage={true}
                        />
                        <br />
                        <HR className="isResultPage" />
                        {earnings !== null &&
                        Object.keys(earnings).length > 0 ? (
                            <Big9PotentialEarnings
                                earnings={earnings}
                                isResultPage
                                ongoingEvent={getOngoingEvent(eventsResults)}
                            />
                        ) : null}
                        <WrapperResultsCards>
                            {eventsResults.length > 0
                                ? getEventsResults(eventsResults)
                                : null}
                        </WrapperResultsCards>
                    </WrapperResultsContent>
                </ResultsCont>
            </Divider>
            <Divider
                padding="0 0 0 39px"
                className="sportRadarWrapper"
                display={isVisibleMobRadar ? 'flex' : 'none'}
            >
                <BackButtonWrapper
                    display={
                        isVisibleMobRadar && window.innerWidth <= 1366
                            ? 'flex'
                            : 'none'
                    }
                >
                    <Button
                        margin="0"
                        padding="10px 15px"
                        fontSize="12px"
                        onClick={() => {
                            hideMatchPlugin();
                        }}
                        lynch
                    >
                        <BackArrow src={backImage} />
                        <span>Tilbage</span>
                    </Button>
                </BackButtonWrapper>

                <SportRadarWidget
                    externalId={externalId}
                    isLive={false}
                    layout={sportRadarType}
                />
            </Divider>
        </WrapperResults>
    );
};

export default Big9Results;
